import * as ActionTypes from "../../Actions/DriverManagement/ActionTypes";
import * as ActionReducer from "./ActionReducer";

const initialState = {
  addExcelFile: {
    request: null,
    response: null,
    error: null,
  },

  DeleteDriver: {
    request: null,
    response: null,
    error: null,
  },

  editDriver: {
    request: null,
    response: null,
    error: null,
  },

  createDriverWithVehicle: {
    request: null,
    response: null,
    error: null,
  },

  getDriver: {
    request: null,
    response: null,
    error: null,
  },

  searchTenantDrivers: {
    request: null,
    response: null,
    error: null,
  },

  searchTenantDriverPersonal: {
    request: null,
    response: null,
    error: null,
  },

  DriverPassword: {
    request: null,
    response: null,
    error: null,
  },

  //dispatchtodriver
  postDriverInfo: {
    request: null,
    response: null,
    error: null,
  },

  activeMissionToDriver: {
    request: null,
    response: null,
    error: null,
  },

  DeleteMissionFromDriver: {
    request: null,
    response: null,
    error: null,
  },

  CreateDistributor: {
    request: null,
    response: null,
    error: null,
  },
  
  DriverOfPlan: {
    error: null,
    request: null,
    response: null,
  },
};

const DriverManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.CLEAR_STATE_DRIVERMNG:
      return ActionReducer.clearState(state, action, initialState);

    case ActionTypes.CREATE_DRIVER_WITH_FILE:
      return ActionReducer.creacteDriverWithfile(state, action);
    case ActionTypes.CREATE_DRIVER_WITH_FILE_SUCCESS:
      return ActionReducer.creacteDriverWithfileSuccess(state, action);
    case ActionTypes.CREATE_DRIVER_WITH_FILE_FAIL:
      return ActionReducer.creacteDriverWithfileFail(state, action);

    case ActionTypes.CHANGE_DRIVER_PASSWORD:
      return ActionReducer.changeDriverPassword(state, action);
    case ActionTypes.CHANGE_DRIVER_PASSWORD_SUCCESS:
      return ActionReducer.changeDriverPasswordSuccess(state, action);
    case ActionTypes.CHANGE_DRIVER_PASSWORD_FAIL:
      return ActionReducer.changeDriverPasswordFail(state, action);

    case ActionTypes.DELETE_DRIVER:
      return ActionReducer.deleteDriver(state, action);
    case ActionTypes.DELETE_DRIVER_SUCCESS:
      return ActionReducer.deleteDriverSuccess(state, action);
    case ActionTypes.DELETE_DRIVER_FAIL:
      return ActionReducer.deleteDriverFail(state, action);

    case ActionTypes.EDIT_DRIVER:
      return ActionReducer.editDriver(state, action);
    case ActionTypes.EDIT_DRIVER_SUCCESS:
      return ActionReducer.editDriverSuccess(state, action);
    case ActionTypes.EDIT_DRIVER_FAIL:
      return ActionReducer.editDriverFail(state, action);

    case ActionTypes.CREATE_DRIVER_WITH_VEHICLE:
      return ActionReducer.createDriverWithVehicle(state, action);
    case ActionTypes.CREATE_DRIVER_WITH_VEHICLE_SUCCESS:
      return ActionReducer.createDriverWithVehicleSuccess(state, action);
    case ActionTypes.CREATE_DRIVER_WITH_VEHICLE_FAIL:
      return ActionReducer.createDriverWithVehicleFail(state, action);

    case ActionTypes.GET_DRIVER:
      return ActionReducer.getDriver(state, action);
    case ActionTypes.GET_DRIVER_SUCCESS:
      return ActionReducer.getDriverSuccess(state, action);
    case ActionTypes.GET_DRIVER_FAIL:
      return ActionReducer.getDriverFail(state, action);

    case ActionTypes.SEARCH_TENANT_DRIVERS:
      return ActionReducer.searchTenantDrivers(state, action);
    case ActionTypes.SEARCH_TENANT_DRIVERS_SUCCESS:
      return ActionReducer.searchTenantDriversSuccess(state, action);
    case ActionTypes.SEARCH_TENANT_DRIVERS_FAIL:
      return ActionReducer.searchTenantDriversFail(state, action);

    case ActionTypes.SEARCH_TENANT_DRIVER_PERSONAL:
      return ActionReducer.searchTenantDriverPersonal(state, action);
    case ActionTypes.SEARCH_TENANT_DRIVER_PERSONAL_SUCCESS:
      return ActionReducer.searchTenantDriverPersonalSuccess(state, action);
    case ActionTypes.SEARCH_TENANT_DRIVER_PERSONAL_FAIL:
      return ActionReducer.searchTenantDriverPersonalFail(state, action);

    case ActionTypes.GET_ALL_DRIVER_OF_PLAN:
      return ActionReducer.getAllDriverOfPlan(state, action);
    case ActionTypes.GET_ALL_DRIVER_OF_PLAN_SUCCESS:
      return ActionReducer.getAllDriverOfPlanSuccess(state, action);
    case ActionTypes.GET_ALL_DRIVER_OF_PLAN_FAIL:
      return ActionReducer.getAllDriverOfPlanFail(state, action);
      
    case ActionTypes.POST_DRIVER_INFO:
      return ActionReducer.postDriverInfo(state, action);
    case ActionTypes.POST_DRIVER_INFO_SUCCESS:
      return ActionReducer.postDriverInfoSuccess(state, action);
    case ActionTypes.POST_DRIVER_INFO_FAIL:
      return ActionReducer.postDriverInfoFail(state, action);

    case ActionTypes.ACTIVE_MISSION_TO_DRIVER:
      return ActionReducer.activeMissionToDriver(state, action);
    case ActionTypes.ACTIVE_MISSION_TO_DRIVER_SUCCESS:
      return ActionReducer.activeMissionToDriverSuccess(state, action);
    case ActionTypes.ACTIVE_MISSION_TO_DRIVER_FAIL:
      return ActionReducer.activeMissionToDriverFail(state, action);

    case ActionTypes.DELETE_MISSION_FROM_DRIVER:
      return ActionReducer.DeleteMissionFromDriver(state, action);
    case ActionTypes.DELETE_MISSION_FROM_DRIVER_SUCCESS:
      return ActionReducer.DeleteMissionFromDriverSuccess(state, action);
    case ActionTypes.DELETE_MISSION_FROM_DRIVER_FAIL:
      return ActionReducer.DeleteMissionFromDriverFail(state, action);

    case ActionTypes.CREATE_DISTRIBUTOR:
      return ActionReducer.CreateDistributor(state, action);
    case ActionTypes.CREATE_DISTRIBUTOR_SUCCESS:
      return ActionReducer.CreateDistributorSuccess(state, action);
    case ActionTypes.CREATE_DISTRIBUTOR_FAIL:
      return ActionReducer.CreateDistributorFail(state, action);

    default:
      return state;
  }
};

export { DriverManagementReducer };
